export default {
  namespaced: true,
  state: {
    // 表单当前页
    stt_currentPageInfo: {
      id: null, // 分页表单当前页id
      index: 0, // 分页表单索引
    },
    // 当前选中控件的父控件
    stt_parentControl: {},
    // 控制控件属性栏是否展开
    stt_settingsOpen: false,
  },
  mutations: {
    // 设置表单当前页
    mtt_setCurrentPageInfo(state, info) {
      state.stt_currentPageInfo = info;
    },
    // 设置父控件
    mtt_parentControl(state, control) {
      state.stt_parentControl = control;
    },

    mtt_settingsOpen(state, status) {
      state.stt_settingsOpen = status;
    },
  },
};
